<template>
  <div
    v-if="!data.length"
    class="font-semibold flex justify-center text-lg m-auto text-center p-4"
  >
    <span>There is no data to display.</span>
  </div>
  <div v-else class=" w-full md:px-5 m-auto py-5">
    <!-- edit form for table row -->
    <EditForm
      :row="editRow"
      :headers="headings"
      :values="values"
      :hide="editHideColumns"
      :submitEdit="submitEdit"
      v-if="editRow.length"
    />

    <!-- begin table -->
    <t-table
      :headers="headingsWithEdit"
      :data="data"
      :responsive="true"
      :responsive-breakpoint="768"
      variant="thin"
    >
      <!-- <template slot="thead">
        <template v-if="headingsWithEdit.length > 9"><div /> </template>
      </template> -->
      <!-- render table with horizontal headings (responsive) -->

      <template
        slot="tbody"
        slot-scope="{tbodyClass, trClass, tdClass, renderResponsive, data}"
      >
        <template v-if="renderResponsive">
          <tbody
            v-for="(row, rowIndex) in data"
            :key="row.id"
            :class="[tbodyClass, rowIndex % 2 === 0 ? 'bg-gray-100' : '']"
          >
            <tr
              :class="[trClass]"
              v-for="(header, headerIndex) in headings"
              :key="header.id"
            >
              <th class="text-xs font-medium text-gray-600 uppercase">
                {{ header }}
              </th>
              <td :class="[tdClass]">
                {{ row[headerIndex] }}
              </td>
              <!-- Delete / Edit menu -->
              <t-dropdown text="..." variant="info" v-if="headerIndex == 0">
                <div slot-scope="{hide}" class=" rounded-md shadow-xs">
                  <button
                    href="#"
                    class="block px-4 py-2 text-left text-gray-800
                    hover:bg-gray-200 w-full"
                    role="menuitem"
                    v-on:click="
                      editRecord(row);
                      hide();
                    "
                  >
                    Edit
                  </button>
                  <button
                    href="#"
                    class="block px-4 py-2 text-left text-gray-800 \
                             hover:text-white hover:bg-red-500 w-full"
                    role="menuitem"
                    v-on:click="delelteRecord(row)"
                  >
                    Delete
                  </button>
                </div>
              </t-dropdown>
            </tr>
          </tbody>
        </template>
      </template>

      <!-- render table row by row -->
      <template slot="row" slot-scope="props">
        <tr
          :class="[
            props.trClass,
            props.rowIndex % 2 === 0 ? 'bg-gray-100' : '',
          ]"
        >
          <td
            :class="props.tdClass"
            v-for="(item, index) in props.row"
            :key="`item-${index}`"
          >
            <p class="text-sm">{{ item }}</p>
          </td>

          <td :class="props.tdClass" v-if="!readOnly">
            <t-dropdown text="..." variant="info">
              <div slot-scope="{hide}" class="py-1 rounded-md shadow-xs">
                <button
                  href="#"
                  class="block px-4 py-2 text-left
                  text-gray-800 hover:bg-gray-200 w-full"
                  role="menuitem"
                  v-on:click="
                    editRecord(props.row);
                    hide();
                  "
                >
                  Edit
                </button>
                <button
                  href="#"
                  class="block px-4 py-2 text-left text-gray-800 \
                hover:text-white hover:bg-red-500 w-full"
                  role="menuitem"
                  v-on:click="delelteRecord(props.row)"
                >
                  Delete
                </button>
              </div>
            </t-dropdown>
          </td>
        </tr>
      </template>
    </t-table>
  </div>
</template>

<script>
import EditForm from './EditForm';
export default {
  name: 'Table',
  components: {
    EditForm,
  },
  /**
   * editHideColumns: argument to EditForm.hide
   */
  props: [
    'items', 'del', 'edit', 'getTheDataInParent', 'readOnly',
    'values', 'editHideColumns'
  ],
  watch: {
    items: function() {
      this.getData();
      this.getHeadings();
    },
  },
  methods: {
    getHeadings: function() {
      try {
        const i = Object.keys(this.items).map((key) => {
          return [Number(key), this.items[key]];
        });

        this.headings = Object.keys(i[0][1]);
        console.log(this.headings);

        this.headingsWithEdit = [...this.headings];
        if (!this.readOnly) {
          this.headingsWithEdit.push('update');
        }
      } catch (_e) {}
    },
    getData: function(val) {
      // convert array to object
      const obj = Object.assign({}, this.items);
      let c = 0;
      const values = [];
      // iterate over entries
      Object.entries(obj).forEach(
        ([_key, value]) => (values[c++] = Object.values(value)),
      );
      this.data = values;
    },
    editRecord(row) {
      this.editRow = row;
    },
    delelteRecord(row) {
      this.$dialog
        .confirm(
          'Delete record?',
          // eslint-disable-next-line max-len
          'This action will delete all occurances and cannot be undone.',
          'info',
        )
        .then((result) => {
          if (result.hideReason === 'ok') {
            this.del(row).then((res) => {
              console.log(res.body);
              if (res.ok) {
                console.log(res);
                this.$vToastify.success('Successfully deleted');
                this.getTheDataInParent();
              } else {
                this.$vToastify.error(
                  'Could not edit, see console for details',
                );
                console.error(res);
              }
            });
          }
        });
    },
    submitEdit(edit) {
      if (edit === 'cancel') {
        this.editRow = [];
        return;
      }
      this.edit(this.editRow, edit, this.headings).then((res) => {
        if (res.ok) {
          console.log(res);
          this.$vToastify.success('Successfully carried out edit');
          this.getTheDataInParent();
        } else {
          this.$vToastify.error('Could not edit, see console for details');
          console.error(res);
        }
      });
      this.editRow = [];
    },
  },
  data() {
    return {
      headings: [],
      data: [],
      selected: [],
      selectedWithComments: [],
      headingsWithEdit: [],
      editRow: [],
    };
  },
};
</script>
